import * as React from "react";
const SvgFiRrCorn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-corn_svg__a)">
      <path
        fill="#062147"
        d="M13 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m9.994 2.2C22.377 20.307 16.862 24 12 24S1.623 20.307 1.006 12.2a2.033 2.033 0 0 1 2.724-2.063q.668.274 1.3.621c1.535-14.263 12.42-14.249 13.95 0q.631-.348 1.3-.622a2.033 2.033 0 0 1 2.714 2.064m-12.035 9.725c-.36-1.343-2.325-7.7-7.965-9.925.54 7.066 4.867 9.491 7.965 9.925m1.04-3.064a19.6 19.6 0 0 1 2.187-3.86A1.008 1.008 0 1 1 14 13h1.9a14 14 0 0 1 1.126-.978c-.012-.344-.012-.688-.037-1.023h-.99a1 1 0 0 1 0-2h.734a15 15 0 0 0-.533-2H14a1 1 0 1 1 0-2h1.323c-2.21-3.944-4.436-3.944-6.646 0H10a1 1 0 0 1 0 2s-2.123-.025-2.185-.037q-.346 1-.548 2.037H8a1 1 0 1 1 0 2h-.988c-.025.335-.025.68-.037 1.023q.588.46 1.125.977H10a1.006 1.006 0 1 1-.186 2A19.6 19.6 0 0 1 12 18.861m9-6.813c-5.634 2.182-7.6 8.535-7.958 9.877 3.098-.433 7.424-2.853 7.959-9.877"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-corn_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCorn;
